import React from 'react';
import {List, Datagrid, TextField} from 'react-admin';

export const EventLogList = props => {
  return (
    <>
      <List
        title='Hydrant Fleet Management - EventLog' 
        exporter={false}
        perPage={50}
      >
        <Datagrid>
          <TextField label="Event Type" source="eventType" />
          <TextField label="Device Id" source="deviceId" />
          <TextField label="Description"source="description" />
          <TextField label="Source" source="source" />
          <TextField label="Severity" source="severity" />
          <TextField label="Start Date" source="startTime" />
          <TextField label="End Date" source="endTime" />
        </Datagrid>
      </List>
    </>  
  );
};

  
  